<template>
  <div class="moreMsg" :class="{ ISIOS: isiOSX }">
    <van-nav-bar title="更多信息" left-arrow @click-left="goBack" />
    <div class="out" :class="{ isIos: isiOSX }">
      <div class="content">
        <p>公司信息（非必填）</p>
        <van-cell-group>
          <van-field v-model="site" placeholder="填写公司地址" maxlength="60" />
          <van-field
            v-model="phone"
            type="tel"
            placeholder="填写公司电话"
            maxlength="30"
          />
        </van-cell-group>
      </div>
      <div class="content">
        <p>公司信息（非必填）</p>
        <van-cell-group>
          <van-field
            v-model="bankOfDeposit"
            placeholder="填写开户银行"
            maxlength="30"
          />
          <van-field
            v-model="bankAccount"
            placeholder="填写银行账号"
            maxlength="30"
          />
        </van-cell-group>
      </div>
      <div class="remark">
        <p>备注（非必填）</p>
        <van-cell-group>
          <van-field
            v-model="remark"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请按照公司报销要求填写～"
            show-word-limit
             @focus="keyboard"
          />
        </van-cell-group>
      </div>
      <div class="button" :class="{ keyboard: iskeyboard }">
        <button @click="showVerify">确认信息</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      site: "",
      phone: "",
      bankOfDeposit: "",
      bankAccount: "",
      remark: "",
      iskeyboard:false
    };
  },
  created() {
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    goBack() {
      if (
        this.site != "" ||
        this.phone != "" ||
        this.bankOfDeposit != "" ||
        this.bankAccount != "" ||
        this.remark != ""
      ) {
        this.$dialog
          .confirm({
            // title: "标题",
            message: "是否要放弃当前编辑的内容",
            cancelButtonColor: "#F9591B",
            confirmButtonColor: "#333333",
          })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      }else{
        this.$router.go(-1);
      }
    },
     keyboard() {
      // 判断是否为ios
      console.log('1111')
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        //IOS
        // console.log("ios")
      } else {
        //安卓
        this.iskeyboard = true;
        // console.log(this.iskeyboard)
        window.setTimeout(function () {
          document.activeElement.scrollIntoView({ block: "center" });
        }, 200);
      }
    },
    // 提交
    showVerify(type) {
      this.$router.replace({
        path: "/takingCar/invoiceDetails",
        query: {
          site: this.site,
          phone: this.phone,
          bankOfDeposit: this.bankOfDeposit,
          bankAccount: this.bankAccount,
          remark: this.remark,
        },
      });
    },
  },
  mounted() {
    this.site = this.$route.query.site;
    this.phone = this.$route.query.phone;
    this.bankOfDeposit = this.$route.query.bankOfDeposit;
    this.bankAccount = this.$route.query.bankAccount;
    this.remark = this.$route.query.remark;
  },
};
</script>

<style lang="less">
.moreMsg {
  background: #f5f6f7;
  min-height: 100%;
  .van-nav-bar {
    background: #ffffff;
    padding-top: 24px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    .van-nav-bar__title {
      font-size: 16px;
      color: #333333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 5px;
      margin-top: 24px;
      .van-icon {
        width: 17px;
        height: 17px;
        display: inline-block;
        background: url(../../assets/selfSupport/backlast@2x.png) no-repeat
          center center;
        background-size: 100% 100%;
      }
    }
  }
  .out {
    margin-top: 70px;
    border: 1px solid rgba(0, 0, 0, 0);
    .content {
      margin-top: 12px;
      background: #ffffff;
      padding-bottom: 15px;
      padding-right: 15px;
      p {
        color: #333333;
        font-size: 15px;
        line-height: 21px;
        font-weight: bolder;
        padding: 15px 0 15px 15px;
      }
      .van-cell {
        padding: 20px 15px;
      }
      .van-cell:last-child::after{
        display: block;
      }
      .van-hairline--top-bottom::after{
        border: none;
      }

    }
    .remark {
      margin-top: 12px;
      background: #ffffff;
      p {
        color: #333333;
        font-size: 15px;
        line-height: 21px;
        font-weight: bolder;
        padding: 15px 0 15px 15px;
      }
      .van-field {
        .van-cell__value {
          background: #f5f6f7;
          padding: 15px;
          border-radius: 6px;
        }
      }
      .van-hairline--top-bottom::after{
        border: none;
      }
    }
    .button {
      width: 100%;
      height: 80px;
      overflow: hidden;
      button {
        float: left;
        margin-left: 3%;
        margin-top: 15px;
        width: 94%;
        align-items: center;
        background: #181818;
        color: #ffffff;
        font-size: 18px;
        line-height: 25px;
        height: 50px;
        border-radius: 5px;
        border: none;
      }
    }
    .keyboard{
      margin-bottom: 200px;
    }
  }
  .isIos {
    margin-top: 90px;
  }
}
.ISIOS{
  .van-nav-bar{
    padding-top: 44px;
    .van-nav-bar__left{
      margin-top: 44px;
    }
  }
}
</style>
